import styled from "@emotion/styled";
import { connectLocation } from "../../location/LocationConnectors";
import { H3 } from '../text-elements/oc-h';
import ResultBlock from './oc-result-block';
import Theme from '../../../themes/index';
import { Column, ColumnedSection, Info } from "../../helpers/grid_view";

const Container = styled.a`
  width: 100%;
  margin: 16px 0;
  text-decoration: none;
  :hover > *{
    color: initial;
  }
  :hover > h3 {
    color: ${Theme.colors.brand};
    text-decoration: none;
  }
  :focus {
    outline: none;
  }
`;

const Heading = styled(H3)`
  margin-bottom: 0;
`
const PostHeading = styled.p`
  margin: 4px 0 0;
`;

const DocumentDetails = styled.span`
  font-size: 12px;
`;

const SDSResultBlock = connectLocation(({ t, result, style }) => {

  return (
    <ResultBlock {...( style && {style : style})}>
      <Container href={result.docUrl}
                 data-track="file-download"
                 data-track-file-name={result.docName}
                 data-track-element-location="search results"
                 data-track-doc-type={result.docType}>

        <Heading font="body">{result.name}</Heading>

        <PostHeading>{result.postheading}</PostHeading>

        <DocumentDetails>
          <strong>{result.docName}</strong> {(result.docFormat || result.docSize) && `| ${result.docFormat} ${result.docSize}`}
        </DocumentDetails>

        <ColumnedSection>
          <Column>
            {result.docType && <Info>{t(`sds.fields.category`)} <strong>{result.docType}</strong></Info>}
            {result.languageName && <Info>{t(`sds.fields.language_iso_code`)} <strong>{result.languageName}</strong></Info>}
            {result.supplierName && <Info>{t(`sds.fields.supplier`)} <strong>{result.supplierName}</strong></Info>}
          </Column>
          <Column>
            {result.regionName && <Info>{t(`sds.fields.region`)} <strong>{result.regionName}</strong></Info>}
            {result.date && <Info>{t(`sds.fields.document_date`)} <strong>{result.date}</strong></Info>}
          </Column>
        </ColumnedSection>
      </Container>
    </ResultBlock>
  )
});

export default SDSResultBlock;
